module.exports = __webpack_public_path__ + "static/media/brooke.9cf6a4bb.jpg";